import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { Orders } from '../features/orders/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const OrdersPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <Orders />
    </ErrorBoundary>
  )
}
